import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static values = { token: String, storeId: Number, snapshotUrl: String }

  connect() {
    let connected = false
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create({ channel: "OrdersChannel", token: this.tokenValue }, {
      received: (event) => { if (Number(event.store_id) === this.storeIdValue) this.refresh() },
      connected: () => {
        if (connected) this.refresh()
        connected = true
      }
    })
  }

  disconnect() { clearTimeout(this.timeout); this.subscription?.unsubscribe(); this.consumer?.disconnect() }

  refresh() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      const url = `${this.snapshotUrlValue}${window.location.search}`
      fetch(url, { headers: { Accept: "text/html" }, credentials: "same-origin" })
        .then((response) => response.ok ? response.text() : null)
        .then((html) => { if (html) document.querySelector("main")?.replaceWith(new DOMParser().parseFromString(html, "text/html").querySelector("main")) })
    }, 250)
  }
}
